<template>
  <div></div>
  <!-- No necesita mostrar nada -->
</template>
<script>
export default {
  created() {
    window.location.replace("https://web.sanchopan.com/");
  },
};
</script>
